import { getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB7fiK605zGMoPYE60MHEsGCAZKpNZpTIo",
  authDomain: "lggestionimmobiliere.firebaseapp.com",
  databaseURL:
    "https://lggestionimmobiliere-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "lggestionimmobiliere",
  storageBucket: "lggestionimmobiliere.appspot.com",
  messagingSenderId: "933521850576",
  appId: "1:933521850576:web:755d2c33dfed59355a1ed5",
  measurementId: "G-45NJ29QFX7",
};

const app =
  getApps().length > 0
    ? getApps()[0]
    : initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };